import { createColumnHelper } from '@tanstack/react-table';

import type { UserPublicTokenType } from '@/utils/hooks/swr/integrations/useUserPublicTokens';

import DateCell from '@/components/pages/settings/integrations/ApiAccessTable/DateCell';
import TableHeaderCell from '@/components/pages/settings/integrations/ApiAccessTable/TableHeaderCell';

class ApiAccessTableService {
    readonly columnHelper = createColumnHelper<UserPublicTokenType>();

    getColumns = (t: (key: string) => string) => [
        this.columnHelper.accessor('name', {
            header: () => (
                <TableHeaderCell t={t} translate_token="api_access.table_keys.column_key_name" />
            ),
            cell: (info) => <span className="text-sm">{info.getValue()}</span>
        }),
        this.columnHelper.accessor('created_at', {
            header: () => (
                <TableHeaderCell t={t} translate_token="api_access.table_keys.column_created_at" />
            ),
            cell: (info) => (
                <DateCell
                    date={info.getValue()}
                    timezone={info.table.options.meta.timezone}
                    dateFormat={info.table.options.meta.date_format}
                />
            )
        }),
        this.columnHelper.accessor('last_use', {
            header: () => (
                <TableHeaderCell t={t} translate_token="api_access.table_keys.column_last_use" />
            ),
            cell: (info) => (
                <DateCell
                    date={info.getValue()}
                    timezone={info.table.options.meta.timezone}
                    dateFormat={info.table.options.meta.date_format}
                />
            )
        })
    ];
}

const apiAccessTableService = new ApiAccessTableService();

export { apiAccessTableService as ApiAccessTableService };
